<template>
  <div class="GlobalTable">
 
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="this.page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="所属系列" slot="seriesName" align="center" width="80px">
        <template slot-scope="{ row }">
          <span>
            {{ row.seriesName || '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="机型标记" slot="mark" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.mark" style="color: red;">
            {{

              row.mark === '00' ? '折叠屏机型' : row.mark === '01' ? '曲面屏机型' : '低端机机型'
            }}
          </div>
          <div v-else>
            --
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="机型来源" slot="channel" align="center" width="120px">
        <template slot-scope="{ row }">
          <span>
            {{ row.channel }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column label="是否启用" slot="operationEnable" align="center">
        <template slot-scope="{ row }">
          <el-switch inactive-color="#bebebe" @change="handleSwitch(row, row.isEnable)"
            v-model="row.isEnable"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="小型号" slot="modelCodeStr" align="center">
        <template slot-scope="{ row }">
          <el-tooltip
             v-if="row.modelCodeStr"
            class="item"
            effect="dark"
            :content="row.modelCodeStr"
            placement="top"
          >
            <div class="nowrap-ellipsis">
              {{ row.modelCodeStr }}
            </div>
          </el-tooltip>
          <span v-else>--</span>
        </template>
      </el-table-column>

      <el-table-column label="询价使用规格" slot="operationSku" align="center" width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.inquirySkuType == '00' ? '统一规格' : '本机规格' }}</span>
          <div class="link danger" @click="editSkuType(row)">修改</div>
        </template>
      </el-table-column>
      <el-table-column label="本机规格" slot="operationLocalSku" align="center" width="90px">
        <template slot-scope="{ row }">
          <span class="link primary" @click="seeLocalSku(row)">查看</span>
        </template>
      </el-table-column>
      <el-table-column label="最高靓机价" slot="maxNicePrice" align="center" width="100px">
        <template slot-scope="{ row }">
          <span>{{ row.maxNicePrice || '暂无' }}</span>
          <div v-if="row.maxNicePrice" class="link warning" @click="seeNicePrice(row)">查看靓机价</div>
        </template>
      </el-table-column>
      <el-table-column label="未绑定渠道" slot="unBindChannel" align="center" min-width="150px">
        <template slot-scope="{ row }">
          <el-tooltip
             v-if="row.unBindChannel"
            class="item"
            effect="dark"
            :content="row.unBindChannel"
            placement="top"
          >
            <div style="color: #ff687b;" class="nowrap-ellipsis">
              {{ row.unBindChannel }}
            </div>
          </el-tooltip>
          <span v-else>暂无</span>
          <div class="link primary" @click="seeBindModel(row)">{{row.unBindChannel?'绑定机型':'查看绑定机型'}}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="排序" slot="operationSort" align="center" width="155px">
        <template slot-scope="{ row }">
          <el-input-number size="mini" v-model="row.sort" @change="handleChangeNum(row)"></el-input-number>
        </template>
      </el-table-column> -->
      <el-table-column width="250" label="操作" slot="operation" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" @click="handleBtn(row, 'edit')" :disabled="row.isEnable">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleBtn(row, 'del')" :disabled="row.isEnable">删除</el-button>
          <el-button size="mini" type="danger" plain v-if="row.mark" @click="handleBtn(row, 'cancel')">取消标记</el-button>
          <el-button size="mini" type="success" v-else @click="handleBtn(row, 'mark')">机型标记</el-button>
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 取消标记 -->
    <el-dialog title="操作提示" :visible.sync="dePhoneShow" :close-on-click-modal="false" width="550px">
      <p style="color: red; margin-bottom: 10px">
        说明：取消后，该机型不再为曲面屏或者折叠屏或低端机
      </p>
      <div class="cance-tip">
        <div class="tip-sure">
          是否确认取消该机型的标记？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dePhoneShow = false">取消</el-button>
        <el-button type="primary" @click="dePhnoeSubmit">确定</el-button>
      </span>
    </el-dialog>
    <!--弹框-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="380px"
      @closed="handleDialogClosed">
      <div v-if="dialogTitle !== '编辑机型'"
        style="font-size:16px;color:#666666;text-align:center;height:100px;line-height:100px">确认要执行该操作吗？</div>
      <el-form v-else ref="form" :model="modelform" label-width="80px">
        <el-form-item label="所属分类">
          <el-select v-model="modelform.machineTypeId" placeholder="请选择分类" @change="typeChange">
            <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属品牌">
          <el-select v-model="modelform.brandId" filterable placeholder="请选择品牌" @change="brandChange">
            <el-option v-for="ele in editOldBrand" :key="ele.id" :label="ele.name" :value="ele.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属系列">
          <el-select v-model="modelform.seriesId" filterable placeholder="请选择系列">
            <el-option v-for="ele in seriesSelectList" :key="ele.key" :label="ele.value" :value="ele.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机型名称">
          <el-input v-model="modelform.name" placeholder="请输入机型名称（限20字以内）"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="handleBtnLoading" @click.native="handleSuccess">确定</el-button>
        <el-button @click.native="handleClose">取消</el-button>
      </span>
    </el-dialog>
    <!-- 机型标记弹框 -->
    <el-dialog title='机型标记' :visible.sync="markShow" :close-on-click-modal="false" width="585px"
      @closed=" markShow = false">
      <div style="color: #FF8080;font-size:14px;margin-bottom: 20px;">说明：标记后店员选择该机型下单时，细节示例图展示对应分类的图片</div>
      <div class="mark">
        <div style="width: 160px;font-weight: 600;"><span style="color: #FF8080">*</span>请选择标记机型分类：</div>
        <div>
          <el-radio-group v-model="markParams.mark">
            <el-radio label="00">折叠屏机型</el-radio>
            <el-radio label="01">曲面屏机型</el-radio>
            <el-radio label="02">低端机机型</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native=" markShow = false">取消</el-button>
        <el-button type="primary" @click.native="showMarkSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改信息" :visible.sync="skuTypeVisible" :close-on-click-modal="false" width="400px">
      <el-form label-width="120px">
        <el-form-item label="询价使用规格:" required>
          <el-radio-group v-model="skuType">
            <el-radio label="00">统一规格</el-radio>
            <el-radio label="01">本机规格</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="skuTypeVisible = false">取消</el-button>
        <el-button type="primary" :loading="skuTypeBtnLoading" @click.native="skuTypeSetSure">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看本机规格" :visible.sync="localSkuVisible" :close-on-click-modal="false" width="600px">
      <div class="local-sku-list" v-loading="localSkuLoading">
        <div v-for="item in localSkuList" :key="item.optionKeyId">
          <p class="title">{{ item.optionKeyName }}</p>
          <div>
            <el-tag type="info" v-for="ele in item.optionList" :key="ele.optionId">{{ ele.optionName }}</el-tag>
          </div>
        </div>
        <div v-if="!localSkuList.length">
          <el-empty :image="require('@/assets/home/tjsjtb.png')"></el-empty>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="resetActionSku">重置规格</el-button>
        <el-button @click.native="localSkuVisible = false">关闭</el-button>
      </span>
    </el-dialog>
     <!-- 重置规格 -->
     <el-dialog title="重置规格" :visible.sync="resetSkuShow" :close-on-click-modal="false" width="550px">
      <p style="color: rgb(255, 104, 123); margin-bottom: 10px">
        说明：重置后将依次获取采货侠、闪回收渠道该机型的最新规格
      </p>
      <div class="cance-tip">
        <div class="tip-sure">
          是否确认重置机型规格？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetSkuShow = false">取消</el-button>
        <el-button type="primary" :loading="resetSkuBtnLoading" @click="resetSkuSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="最高回收价"
      :visible.sync="highPriceShow"
      :close-on-click-modal="false"
      width="700px"
    >
      <div style="padding-bottom: 50px;">
        <GlobalTable
          ref="GlobalTable"
          v-loading="highPriceTableLoading"
          :columns="highPriceTableColumns"
          :data="highPriceTableData"
          :maxHeight="500"
          :isPagination="false"
        >
        </GlobalTable>
      </div>
    </el-dialog>
    <ChannelBindDia v-if="channelBindDiaShow" :dialogVisible="channelBindDiaShow" :currentRow="currentRow" @close="channelBindDiaClose" />
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import _api from "@/utils/request";
import { confirm } from '@/components/common/messagebox'
import ChannelBindDia from "./dialog/ChannelBindDia.vue";

export default {
  components: { ChannelBindDia },
  name: "Table",
  mixins: [MinXinRequest],
  props: {
    classList: Array,
    oldBrand: Array,
    channelList: Array
  },
  data() {
    return {
      resetSkuShow:false,
      loading: false,
      dePhoneShow: false,
      // 标记机型
      markShow: false,
      markParams: {
        mark: '',
        modelId: ''
      },
      seachDataList: [],
      modelform: {
        machineTypeId: '',
        brandId: '',
        seriesId: '',
        name: '',
      },
      ModelEnable: {
        id: "",
        isEnable: ""
      },
      ResidentHot: {
        id: "",
        isHot: ""
      },
      pageNum: 1,
      //弹窗
      dialogVisible: false, // 弹框的出现与否
      dialogTitle: "", // 标题
      handleBtnLoading: false,
      tableColumns: [
        { label: "机型名称", prop: "name" },
        { label: "所属分类", prop: "typeName" },
        { label: "所属品牌", prop: "brandName" },
        { slotName: "seriesName" },
        { label: "报价次数", prop: "quotedNum" },
        { slotName: "mark" },
        { slotName: "channel" },
        { slotName: "operationEnable" },
        { slotName: "modelCodeStr" },
        { slotName: "operationSku" },
        { slotName: "operationLocalSku" },
        { slotName: "maxNicePrice" },
        { slotName: "unBindChannel" },
        { slotName: "operationSort" },
        { label: "添加时间", prop: "createTime", width: "150px" },
        { slotName: "operation" }
      ],
      skuType: '',
      skuTypeVisible: false,
      skuTypeBtnLoading: false,
      rowId: "",
      localSkuVisible: false,
      localSkuLoading: false,
      localSkuList: [],
      // 最高回收价弹框
      highPriceShow: false,
      highPriceTableLoading: false,
      highPriceTableData: [],
      highPriceTableColumns: [
        { label: "容量", prop: "capacity" },
        { label: "靓机价", prop: "nicePrice" },
        { label: "来源", prop: "channelName" },
        { label: "最近更新时间", prop: "createTime" },
      ],
      // 渠道绑定弹框
      channelBindDiaShow: false,
      seriesSelectList: [], //系列下拉列表
      editOldBrand: [],
      currentRow: {},
      skuData:{},
      resetSkuBtnLoading:false,
    };
  },
  created() {
    this.editOldBrand = this.oldBrand
  },
  computed: {
    seachTotal() {
      return this.$store.state.tagsView.seachTotal;
    },
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    }
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.pageNum = 1
      this.handleCurrentChange();
    },
  },
  methods: {
    resetActionSku(){
      this.resetSkuShow = true;
    },
    // 重置规格
    resetSkuSubmit() {
      this.resetSkuBtnLoading=true
      _api.refreshSku({
          "command": "",
          "machineModelIds": [this.skuData.id]
        }).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.resetSkuShow = false
          this.localSkuLoading = true
          _api.getModelSkuList({ id: this.skuData.id }).then(res => {
            if (res.code === 1) {
              this.localSkuList = res.data
            }
            this.localSkuLoading = false
          })
        }).finally(()=>{
          this.resetSkuBtnLoading=false
        })
    },
    // 修改排序
    sortSubmit() {
      this.sortBtnLoading = true
      _api.modelSort({ id: this.ModelEnable.id, sort: this.ModelEnable.sort }).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
        })
      },
    dePhnoeSubmit() {
      _api.phonecancelMark({ modelId: this.ModelEnable.id }).then(res => {
        this.$message({
          type: 'success',
          message: '取消成功!'
        });
        this.dePhoneShow = false
        this.handleCurrentChange();
      })
    },
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.pageNum = val
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }
      const baseRequest = {
        name: this.SeachParams.name,
        machineTypeId: this.SeachParams.machineTypeId,
        brandId: this.SeachParams.brandId,
        seriesId: this.SeachParams.seriesId,
        mark: this.SeachParams.mark,
        hasModelCode: this.SeachParams.hasModelCode,
        modelCode: this.SeachParams.modelCode,
        channel: this.SeachParams.channel,
        inquirySkuType: this.SeachParams.inquirySkuType,
        isEnable: this.SeachParams.isEnable,
        pageNum: this.page.pageNum,
        pageSize: this.SeachParams.pageSize
      };
      this.$emit("handleCurrentChange", val);
      this.loading = true
      _api.modelList(baseRequest).then(res => {
        if (res.code === 1) {
          this.seachDataList = res.data.records || [];
          this.page.pageNum = res.data.current;
          this.page.total = res.data.total;
          this.$store.commit("tagsView/POST_TOTAL", res.data.total);
          this.$store.commit("tagsView/POST_RESIDENT", this.seachDataList);
        }
      }).finally(() => {
        this.loading = false
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    cancelBind(model, row) {
      const { channel, channelName, outModelName } = model
      console.log(channel,'channelchannel');
      let desc =  `说明：取消绑定后，无法通过选择该机型查询原${channelName}关联机型的预估价`
      if(channel === 'chxs' || channel === 'hi' || channel === 'cmcc' || channel === 'dh' || channel === 'lb' || channel === 'lbts' || channel === 'cl-jxy'){
        desc = `说明：取消绑定后，该渠道使用该机型下单将默认为其他机型`
      }
      confirm({
        title: '取消绑定提示',
        width: '550px',
        desc,
        message: `是否确认取消<span style="color: red">${row.name}</span>与${channelName}机型<span style="color: red">${outModelName}</span>的绑定关系？`,
        confirm: () => {
          _api.cancelBind({
            channel: channel,
            machineId: row.id
          }).then(() => {
            this.$message({
              type: 'success',
              message: '取消成功!'
            });
            this.handleCurrentChange();
          })
        }
      })
    },
    // 表格按钮操作
    handleBtn(row, type) {
      console.log("表格操作", type, row);
      if (type == 'edit') {
        this.dialogTitle = "编辑机型";
        this.dialogVisible = true;
        this.ModelEnable.id = row.id;
        this.modelform = {
          id: row.id,
          machineTypeId: row.typeId,
          brandId: row.brandId,
          seriesId: row.seriesId,
          name: row.name
        }
        this.getSeriesSelected()
      } else if (type == 'del') {
        this.dialogTitle = "删除机型";
        this.dialogVisible = true;
        this.ModelEnable.id = row.id;
      } else if (type == 'cancel') {
        this.dePhoneShow = true;
        this.ModelEnable.id = row.id;
      } else {
        console.log(Boolean(row.mark), 'aaa');
        this.markShow = true
        this.markParams.modelId = row.id
        this.markParams.mark = row.mark
      }
    },
    // 机型标记确定
    showMarkSubmit() {
      _api.modelMark(this.markParams).then(res => {
        if (res.code === 1) {
          this.markShow = false
          this.markParams.mark = ''
          // 刷新列表
          this.handleCurrentChange(this.page.pageNum);
        }
      });
    },
    //禁止/启用机型
    handleSwitch(row, val) {
      if (val) {
        this.dialogTitle = "启用机型";
      } else {
        this.dialogTitle = "禁用机型";
      }
      this.ModelEnable.id = row.id;
      this.ModelEnable.isEnable = row.isEnable;
      this.dialogVisible = true;

    },
    // 商品热门
    hotSwitch(row) {
      console.log(row);
      _api.ResidentHot({ id: row.id, isHot: row.isHot }).then(res => {
        this.$message({
          message: res.msg,
          type: 'success'
        });
      })
    },
    // //弹窗取消
    handleClose() {
      this.dialogVisible = false;
    },
    //弹窗确定
    handleSuccess() {
      this.handleBtnLoading = true;
      if (this.dialogTitle === '启用机型' || this.dialogTitle === '禁用机型') {
        _api.modelDisable(this.ModelEnable).then(res => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        }).finally(()=>{
          this.handleBtnLoading = false;
        });
      } else if (this.dialogTitle === '删除机型') {
        _api.modelDelete(this.ModelEnable).then(res => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        }).finally(()=>{
          this.handleBtnLoading = false;
        });
      } else {
        _api.modelEdit(this.modelform).then(res => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        }).finally(()=>{
          this.handleBtnLoading = false;
        });
      }


    },
    handleDialogClosed() {
      this.dialogVisible = false;
      this.handleCurrentChange(this.pageNum);
    },
    //排序
    handleChangeNum(val) {
      const params = {
        id: val.id,
        sort: val.sort
      };
      _api.modelSort(params).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    editSkuType(row) {
      this.rowId = row.id
      this.skuTypeVisible = true
      this.skuType = row.inquirySkuType || '00'
    },
    skuTypeSetSure() {
      this.skuTypeBtnLoading = true
      _api.updateInquirySkuType({ inquirySkuType: this.skuType, id: this.rowId }).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg || '操作成功');
          this.skuTypeVisible = false
          this.handleCurrentChange(this.page.pageNum)
        }
      }).finally(() => {
        this.skuTypeBtnLoading = false
      })
    },
    seeLocalSku(row) {
      this.skuData=row;
      this.localSkuVisible = true
      this.localSkuLoading = true
      _api.getModelSkuList({ id: row.id }).then(res => {
        if (res.code === 1) {
          this.localSkuList = res.data
        }
        this.localSkuLoading = false
      })
    },
    // 查看靓机价
    seeNicePrice(row) {
      this.highPriceShow = true;
      this.highPriceTableLoading = true;
      _api.getModelCapacityNiceList({id: row.id}).then(res => {
        this.highPriceTableData = res.data || [];
        this.highPriceTableLoading = false;
      })
    },
    // 查看绑定机型
    seeBindModel(row) {
      this.currentRow = row;
      this.channelBindDiaShow = true;
    },
    channelBindDiaClose() {
      this.channelBindDiaShow = false;
      this.handleCurrentChange()
    },
    typeChange() {
      this.modelform.brandId = ""
      this.modelform.seriesId = ""
      this.editOldBrand = []
      this.seriesSelectList = []
      this.getResidentList()
      this.getSeriesSelected()
    },
    brandChange() {
      this.modelform.seriesId = ""
      this.seriesSelectList = []
      this.getSeriesSelected()
    },
    // 获取旧机品牌列表
    getResidentList() {
      _api.ResidentList({typeId:this.modelform.machineTypeId}).then(res => {
        this.editOldBrand = res.data
      })
    },
    // 获取系列下拉列表
    getSeriesSelected() {
      let params = {
        typeId:this.modelform.machineTypeId,
        brandId:this.modelform.brandId,
        isFilterDelete: true, //是否过滤删除
      }
      _api.getSeriesSelected(params).then(res => {
        this.seriesSelectList = res.data
      })
    },
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.mark {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.mark-color {
  background-color: #838383;
  border-color: #838383;
}

.el-button--info.is-disabled,
.el-button--info.is-disabled:hover {
  background-color: #838383 !important;
  border-color: #838383 !important;
}

.link {
  text-decoration: underline;
  cursor: pointer;

  &.primary {
    color: #0981ff;
  }

  &.danger {
    color: #ff687b;
  }
  &.warning {
    color: #FFAF29;
  }
}

.cance-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 10px;

  .tip-sure {
    margin-top: 5px;
    color: #333333;
    font-size: 15px;
    text-align: center;
  }
}

.local-sku-list {
  .title {
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  /deep/.el-tag.el-tag--info {
    margin-right: 20px;
    margin-bottom: 10px;
    color: #666666;
    border-color: #999999;
  }
}
.nowrap-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
